import { CLAIM_TYPE } from "./system-default-data-constant";

export enum PreAuthType {
  Institutional = 0,
  Dental = 1,
  Pharmacy = 2,
  Professional = 3,
  Optical = 4
}

export const PreAuthTypeValue: { [key in PreAuthType]: string } = {
  [PreAuthType.Institutional]: CLAIM_TYPE.INSTITUTIONAL,
  [PreAuthType.Dental]: CLAIM_TYPE.DENTAL,
  [PreAuthType.Professional]: CLAIM_TYPE.PROFESSIONAL,
  [PreAuthType.Pharmacy]: CLAIM_TYPE.PHARMACY,
  [PreAuthType.Optical]: CLAIM_TYPE.OPTICAL
};

export const PreAuthTypeLabel: { [key in PreAuthType]: string } = {
  [PreAuthType.Institutional]: "Institutional",
  [PreAuthType.Dental]: "Dental",
  [PreAuthType.Professional]: "Professional",
  [PreAuthType.Pharmacy]: "Pharmacy",
  [PreAuthType.Optical]: "Optical"
};

export enum PreAuthItemEntityType {
  Code = 0,
  Unit = 1,
  Package = 2,
}

export const PreAuthItemEntityTypeLabel: { [key in PreAuthItemEntityType]: string } = {
  [PreAuthItemEntityType.Code]: 'FORM_FIELD.CODE',
  [PreAuthItemEntityType.Unit]: 'FORM_FIELD.UNIT',
  [PreAuthItemEntityType.Package]: 'FORM_FIELD.PACKAGE',
};

export const PreAuthItemEntityTypeValue: { [key in PreAuthItemEntityType]: string } = {
  [PreAuthItemEntityType.Code]: 'cb870d2c-d10c-4a38-b620-7eb40bce2672',
  [PreAuthItemEntityType.Unit]: 'b555403f-80fc-4ec1-a05a-6a6fe9bbdbdc',
  [PreAuthItemEntityType.Package]: 'a4eb4325-6d65-40fe-8e47-21581cd96e30',
};

export enum PreauthTransaction {
  Transaction = 1,
  ApprovalQueue = 2,
  MyApproval = 3,
  AdvancePreauth = 4,
  Claim = 5,
  MyClaim = 6,
  ClaimTransaction = 7,
  ClaimUpload = 8,
  ClaimResubmit = 9,
  Prescription = 10,
  PrescriptionQueue = 11,
  MyPrescription = 12,
  PreauthTransaction = 13,
  PrescriptionTransaction = 14,
  PatientPreauth = 15,
  PatientClaim = 16,
  PatientPrescription = 17,
  PreauthReview = 18,
  BatchClaim = 19,
}

export enum ApprovalSubType {
  Preauth = '0',
  AdvancePreauth = '1',
  Claim = '2',
  Prescription = '3'
}
